import { BreadcrumbItem, Col, Row } from "reactstrap"
import { Link } from "react-router-dom"

import PropTypes from "prop-types"
import React from "react";
import { getPrimaryTextClass } from "helpers/sf_utils";

const GenericBreadcrumb = ({ breadcrumbItem, title, breadcrumbItemRight, backLink, backOption }) => {
  return (
    <Row>
      <Col md={12} xs="12">
        <div className="page-title-box pb-2 d-sm-flex align-items-center justify-content-between">
          <h4 className="text-capitalize text-black mb-0 font-size-18">
            {backOption &&
              <Link to={backLink}>
                <i className={`bx bx-arrow-back ${getPrimaryTextClass()} font-size-16 me-2 bx-sm`} />
              </Link>
            }
            {breadcrumbItem}
          </h4>
          <div className="page-title-right">
            <ol className="breadcrumb m-0">
              <BreadcrumbItem>
                <Link to="#">{title}</Link>
              </BreadcrumbItem>
              <BreadcrumbItem>
                <Link to="#">{breadcrumbItemRight || breadcrumbItem}</Link>
              </BreadcrumbItem>
            </ol>
          </div>
        </div>
      </Col>
    </Row>
  )
}

GenericBreadcrumb.propTypes = {
  breadcrumbItem: PropTypes.string,
  title: PropTypes.string,
  backOption: PropTypes.bool
}
export default GenericBreadcrumb
